import { Col, Row } from "antd";

export function OurService(props) {
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <HomeContent />
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <div className="ourse-services-ph">
          <Services />
        </div>
      </Col>
    </Row>
  )
}

function HomeContent(props) {
  return (
    <div className="services-box-pc">
      <div className="our-services-text">
        <div className="cn-text">我们的服务</div>
        <div className="en-text">OUR SERVICES</div>
      </div>
      <div className="homepage-content1">
        <div className="courseicon-box">
          <div>
            <div className="img-one"></div>
            <div className="txt">
              <span>线上绘画课程</span>
            </div>
            <div className="online">ONLINE PAINTING COURSE</div>
            <div className="decide"></div>
            <div className="bottom-txt">
              <span>系统学习、基础全覆盖</span>
            </div>
          </div>
          <div className="box2">
            <div className="img-two"></div>
            <div className="txt">
              <span>免费学习社区</span>
            </div>
            <div className="free-learning">FREE LEARNING COMMUNITY</div>
            <div className="decide"></div>
            <div className="bottom-txt">
              <span>最适合新手的免费学习社区</span>
            </div>
          </div>
          <div>
            <div className="img-three"></div>
            <div className="txt">
              <span>线上活动</span>
            </div>
            <div className="offline">ONLINE ACTIVITIES</div>
            <div className="decide"></div>
            <div className="bottom-txt">
              <span>绘画竞技，前辈分享直播等你来 </span>
            </div>
          </div>
        </div>
      </div>
      <div className="our-services-text2">
        <div className="cn-text">我们的课程</div>
        <div className="en-text">OUR COURSE</div>
      </div>
    </div>
  );
}

function Services(props) {
  return (
    <div className="services-box">
      <div className="service-text">
        <div className="cn-service">我们的服务</div>
        <div className="en-service">
          <span>OUR</span>
          <span> SERVICES</span>
        </div>
      </div>
      <div className="service-img-icon">
        <div>
          <div className="img-one-ph"></div>

          <div className="line"></div>
          {/* <div className="en-online"><span>ONLINE</span><span>PAINTING</span><span>COLOR</span></div> */}
          {/* <div >系统学习，基础全覆盖</div> */}
        </div>
        <div className="ajust2">
          <div className="img-two-ph"></div>

          {/* <div className="en-online"><span>FREE</span><span>LEARNING</span><span>COMMUNITY</span></div> */}
          {/* <div >最适合新手的免费学习社区</div> */}
        </div>
        <div className="ajust3">
          <div className="img-three-ph"></div>
          {/* <div className="en-online"><span>OFFLINE</span><span>ACTIVETIES</span></div> */}
        </div>
      </div>
      <div className="service-text-box">
        <div className="cn-online"><span>线上绘画课程</span></div>
        <div className="cn-free"><span>免费学习社区</span></div>
        <div className="cn-offline"><span>线上活动</span></div>
      </div>
      <div className="en-service-text">
        <div className="cls1"></div>
        <div className="cls2"></div>
        <div className="cls3"></div>
        {/* <div><span>ONLINE PAINTING COURSE</span></div>
        <div><span>FREE LEARNING COMMUNITY</span></div>
        <div className="last-ajust"><span>ONLINE ACTIVETIES</span></div> */}
      </div>
      <div className="service-line">
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
      <div className="service-cn-index">
        <div><span>系统学习、基础全覆盖</span></div>
        <div><span>最适合新手的免费学习社区</span></div>
        <div><span>绘画竞技，前辈分享直播等你来</span></div>
      </div>
      <div className="service-text2">
        <div className="cn-service">我们的课程</div>
        <div className="en-service">
          <span>OUR</span>
          <span> COURSE</span>
        </div>
      </div>
    </div>
  )
}